import { CustomCarrierCodes } from "@commerce/shared/constants/CustomCarrierCodes";

export const isDeliveryMethodAtHomeDelivery = (methodAndCarrier?: string): boolean => {
  if (typeof methodAndCarrier !== "string") {
    return false;
  }
  // CustomCarrierCode.jtiPickup represents a custom delivery option.
  // If the methodAndCurrier does not include this option,
  // it suggests that it's a home delivery.
  if (!methodAndCarrier) {
    return true;
  }

  return !methodAndCarrier.includes(CustomCarrierCodes.jtiPickup);
};
